import type { OperationResult } from "@urql/vue";
import { handleCombinedError } from "./handleCombinedError.helper";
import { handleErrors } from "./handleErrors.helper";

export async function executeMutation<T>(
  getNestedResult: (data: T | undefined) =>
    | {
        errors: Array<string>;
        success: boolean;
        errorDetails?: { message?: string | null } | null;
      }
    | undefined
    | null,
  mutation: () => Promise<OperationResult<T>>,
  translateError = true,
) {
  const { error, data } = await mutation();
  const result = getNestedResult(data);
  const errors = result?.errors;

  if (error) return handleCombinedError(error);
  if (errors && errors.length > 0)
    return handleErrors(errors, translateError, result?.errorDetails?.message);

  return undefined;
}
